import React from "react";
import {
  Landmark,
  FileCheck2,
  MoveDiagonal,
  Search,
  ExternalLink,
  FileText,
  XCircle,
  Ban,
  Flag,
  Copy,
  CheckCircle2,
  Clock,
  ChevronRight,
} from "lucide-react";

const aiSuggestions = [
  {
    rank: 1,
    invoice: "INV-2024-0099",
    subtitle: "Invoice · Al Fardan",
    date: "22 Aug 2026",
    amount: "+ 113,789.00",
    confidence: 91,
    tone: "high",
    rationale:
      "Reference token 'INV0099' has 91% similarity to invoice INV-2024-0099. Amount matches within tolerance. Counterparty name 'Al Fardan' is a 96% match.",
  },
  {
    rank: 2,
    invoice: "INV-2024-0099",
    subtitle: "Invoice · Al Fardan",
    date: "22 Aug 2026",
    amount: "+ 113,789.00",
    confidence: 76,
    tone: "mid",
    rationale: "Amount difference AED 25. Reference partially matches.",
  },
  {
    rank: 3,
    invoice: "INV-2024-0099",
    subtitle: "Invoice · Al Fardan",
    date: "22 Aug 2026",
    amount: "+ 113,789.00",
    confidence: 56,
    tone: "low",
    rationale: "Counterparty matches. Amount variance higher than usual.",
  },
];

const timeline = [
  {
    time: "23 Jul 2026, 09:14 AM",
    label: "Bank transaction imported from Emirates NBD.",
    state: "done",
  },
  {
    time: "23 Jul 2026, 09:15 AM",
    label: "AI found 3 possibility matches.",
    state: "done",
  },
  {
    time: "23 Jul 2026, 09:15 AM",
    label: "Marked as partially matched — awaiting review.",
    state: "pending",
  },
];

const otherActions = [
  { icon: XCircle, label: "Skip" },
  { icon: Ban, label: "Write Off" },
  { icon: Flag, label: "Flag for Investigation" },
  { icon: Copy, label: "Mark as Duplicate" },
];

export const ReviewDetails = () => {
  return (
    <div className="gx-review-details">
      {/* Top status bar */}
      <div className="gx-topbar">
        <div className="gx-topbar-left">
          <span>Status:</span>
          <span className="gx-badge gx-badge--amber">Partially Matched</span>
        </div>
        <div className="gx-topbar-right">Matched on 23 Jul 2026, 09:15 AM</div>
      </div>

      {/* Two info cards */}
      <div className="gx-grid-two">
        <div className="gx-card">
          <h3 className="gx-card-title">
            <Landmark size={16} />
            1. Credit Transaction Details
          </h3>
          <div className="gx-field-grid">
            <div>
              <div className="gx-field-label">Value Date</div>
              <div className="gx-field-value">22 Jul 2026</div>
            </div>
            <div>
              <div className="gx-field-label">Received From</div>
              <div className="gx-field-value">Al Fardan (Money Transfer)</div>
            </div>
            <div>
              <div className="gx-field-label">Bank Date</div>
              <div className="gx-field-value">22 Jul 2026</div>
            </div>
            <div>
              <div className="gx-field-label">Reference</div>
              <div className="gx-field-value">Invoice #2024-0100</div>
            </div>
            <div>
              <div className="gx-field-label">Amount</div>
              <div className="gx-field-value gx-field-value--amount">
                + 113,789.00
              </div>
            </div>
            <div>
              <div className="gx-field-label">Transaction ID</div>
              <div className="gx-field-value">FYY345678978</div>
            </div>
            <div>
              <div className="gx-field-label">Status</div>
              <div className="gx-pill-status">Paid</div>
            </div>
            <div>
              <div className="gx-field-label">Bank</div>
              <div className="gx-field-value">Emirates NDB</div>
            </div>
          </div>
          <button className="gx-link-btn" type="button">
            View Bank Statement Entry
            <ExternalLink />
          </button>
        </div>

        <div className="gx-card">
          <h3 className="gx-card-title">
            <FileCheck2 size={16} />
            2. Matched Invoice Information
          </h3>
          <div className="gx-field-grid">
            <div>
              <div className="gx-field-label">Match Status</div>
              <span className="gx-badge gx-badge--amber">
                Partially Matched
              </span>
            </div>
            <div>
              <div className="gx-field-label">Final Confidence Score</div>
              <div className="gx-conf-score">76 %</div>
              <div className="gx-conf-bar-mini" />
            </div>
            <div>
              <div className="gx-field-label">Match Method</div>
              <span className="gx-badge gx-badge--blue">AI Auto Match</span>
            </div>
            <div>
              <div className="gx-field-label">Matched On</div>
              <div className="gx-field-value">23 Jul 2026, 09:15 AM</div>
            </div>
            <div>
              <div className="gx-field-label">Matched By</div>
              <div className="gx-field-value">--</div>
            </div>
          </div>
          <button className="gx-link-btn" type="button">
            View Invoice
            <ExternalLink />
          </button>
        </div>
      </div>

    </div>
  );
};

export default ReviewDetails;
